import { COLORS, DETAIL_TOKENS } from '../../../styles/UISystem';

/**
 * DetailSectionCard — the one container treatment for connection detail-page
 * sections (2026-08-18 Detail frames).
 *
 * Before this, three sections used three different strategies: ABOUT had a grey
 * card, LIVES IN had a bare left-inset line, PHOTOS had a bare grid, and the
 * Anon page carried a fourth — its own local DetailCard with a different grey
 * (#F9F9FB) and an uppercase label. The frames show one card: light grey, a
 * quiet sentence-case label inside when the content needs naming, centred.
 *
 * The fill is COLORS.LIGHT_GRAY — measured off the frames, where these
 * containers and the locked contact rows share the same #F7F7F9.
 *
 * @param {string} label - optional quiet label inside the card ("Lives in").
 *   ABOUT carries none: the role line names it.
 * @param {object} style - optional overrides (spacing)
 */
const DetailSectionCard = ({ label, style, children }) => (
  <div
    style={{
      width: '100%',
      maxWidth: DETAIL_TOKENS.SECTION_MAX_WIDTH,
      backgroundColor: COLORS.LIGHT_GRAY,
      borderRadius: '20px',
      padding: '16px',
      boxSizing: 'border-box',
      ...style,
    }}
  >
    {label && (
      <div
        style={{
          fontSize: '13px',
          fontWeight: 400,
          color: '#8E8E93',
          textAlign: 'center',
          marginBottom: '6px',
        }}
      >
        {label}
      </div>
    )}
    {children}
  </div>
);

export default DetailSectionCard;
